
const modalStyles = {
    overlay: {
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, 
        backgroundColor: 'rgba(0, 0, 0, 0.7)', display: 'flex', 
        justifyContent: 'center', alignItems: 'center', zIndex: 1000 
    },
    content: {
        backgroundColor: 'white', padding: '30px', borderRadius: '8px', 
        width: '60%', maxWidth: '90%', height: '70%'
    }
};

function CreateEventModal({ isOpen, onClose, onCreateSubmit }) {
    
   
    const handleSubmit = (e) => {
        e.preventDefault();
        
        const fileInput = e.target.elements.file;
        const rawFile = fileInput.files[0];
        // Pass the form data up to the parent component for API submission
        onCreateSubmit({
            imageFile: rawFile,
            fileName: rawFile.name
        });

       
        
        // Close the modal
        onClose();
    };
    const handleCancel = (e) => {
        // Reset the form data after submission
        // setFormData({  url: '' });
        
        // Close the modal
        onClose();

    };

    if (!isOpen) return null;

    return (
        <div style={modalStyles.overlay}>
            <div style={modalStyles.content}>
                <h3>Create New Item</h3>
                <form onSubmit={handleSubmit}>
                    <div className="row g-2 d-flex flex-column">
                    <input
                        type="file"
                        name="file"
                        required
                    />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '15px' }}>
                        <button type="button" className="btn btn-outline-secondary" onClick={handleCancel} style={{ marginRight: '10px' }}>Cancel</button>
                        <button type="submit" className="btn btn-primary">Create</button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default CreateEventModal;